import React, { useState, useEffect } from 'react';
import { dico_privileges } from '../../../ressources/functionJS/translationService';
import Checkbox from './Checkbox/Checkbox';

function arrayEquals(a, b) {
  return (
    Array.isArray(a) &&
    Array.isArray(b) &&
    a.length === b.length &&
    a.every((val, index) => val === b[index])
  );
}

const ListePrivilegesDetaillees = ({
  defaultChecked,
  remontePrivilegePersonnalise,
}) => {
  const [dynamicDefaultCheckboxValues, setDynamicDefaultCheckboxValues] =
    useState([]);

  useEffect(() => {
    if (defaultChecked?.length > 0) {
      setDynamicDefaultCheckboxValues(defaultChecked);
      remontePrivilegePersonnalise(defaultChecked);
    }
  }, [
    setDynamicDefaultCheckboxValues,
    defaultChecked,
    remontePrivilegePersonnalise,
  ]);

  useEffect(() => {
    if (
      defaultChecked?.length > 0 &&
      !arrayEquals(defaultChecked, dynamicDefaultCheckboxValues)
    ) {
      setDynamicDefaultCheckboxValues(defaultChecked);
      remontePrivilegePersonnalise(dynamicDefaultCheckboxValues);
    }
  }, [
    defaultChecked,
    dynamicDefaultCheckboxValues,
    remontePrivilegePersonnalise,
  ]);

  const onChangeDefaultCheckboxValueHandler = (privilegeSelection) => {
    const newValues = [...dynamicDefaultCheckboxValues];
    const intPrivilege = parseInt(privilegeSelection);
    const index = newValues.indexOf(intPrivilege);

    if (index > -1) {
      newValues.splice(index, 1);
    } else {
      newValues.push(intPrivilege);
    }

    setDynamicDefaultCheckboxValues(newValues);
    remontePrivilegePersonnalise(newValues);
  };
  const radioChoice = Object.keys(dico_privileges).map((clePrivilege) => {
    const currentLangueSite = localStorage.getItem('langueSite') || 'fr';
    return (
      <Checkbox
        key={clePrivilege}
        name={dico_privileges[clePrivilege][currentLangueSite]}
        selectRadio={() => onChangeDefaultCheckboxValueHandler(clePrivilege)}
        checked={
          dynamicDefaultCheckboxValues.indexOf(parseInt(clePrivilege)) > -1
        }
      >
        {`${clePrivilege}: ${dico_privileges[clePrivilege][currentLangueSite]}`}
      </Checkbox>
    );
  });

  return <>{radioChoice}</>;
};

export default ListePrivilegesDetaillees;
